module.exports = __webpack_public_path__ + "img/timer_blue.29d91fc4.svg";